var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"changelogModal","visible":_vm.visible,"title":"Versionshinweise","size":"lg","ok-only":"","scrollable":""},on:{"ok":_vm.setVersion,"hide":_vm.setVersion}},[_c('Changelog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }